module.exports = __webpack_public_path__ + "static/assets/30739a9d6fe024c005411f96dfbdfcd1.png";